import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  domains: [],
  domain: null
}

// mutations
export const mutations = {
  [types.SET_DOMAINS] (state, domains) {
    state.domains = domains
  },
  [types.SET_DOMAIN] (state, domain) {
    state.domain = domain
  },
  [types.FETCH_DOMAIN_FAILURE] (state) {
    state.domain = null
  }
}

// actions
export const actions = {
  async fetchDomains ({ commit }) {
    try {
      const { data } = await axios.get('/domains')
      commit(types.SET_DOMAINS, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchDomain ({ commit }, domain) {
    try {
      const { data } = await axios.get(`/domains/${domain.id}`)

      commit(types.SET_DOMAIN, { domain: data })
    } catch (e) {
      commit(types.FETCH_DOMAIN_FAILURE)
    }
  },

  async createDomain (context, domain) {
    try {
      await axios.post('/api/domains', domain)
      context.dispatch('fetchDomains')
    } catch (e) {
      console.log(e)
    }
  },

  async updateDomain (context, domain) {
    try {
      await axios.put(`/api/domains/${domain.id}`, domain)
      context.dispatch('fetchDomains')
    } catch (e) { }
  },

  async deleteDomain (context, domain) {
    try {
      await axios.delete(`/api/domains/${domain.id}`)
      context.dispatch('fetchDomains')
    } catch (e) { }
  }
}

// getters
export const getters = {
  domains: state => state.domains
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/domain.js